export * from './markt-berichte.page';
export * from './markt-berichte.page.resolver';
